import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { USER_ROLES } from '../../utils/constants';
import Loader from '../common/Loader';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader size="lg" text="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role access
  if (requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.includes(user.role);
    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // COMPANY_ADMIN should NOT access dashboard or users page
  if (user.role === USER_ROLES.COMPANY_ADMIN) {
    const restrictedPaths = ['/admin/dashboard', '/admin/users'];
    if (restrictedPaths.includes(location.pathname)) {
      return <Navigate to="/admin/hosts" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
